module.exports = __webpack_public_path__ + "static/img/13areaA_6.7455868.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/13areaA_6.png
// module id = 1005
// module chunks = 1